import { gql } from '@apollo/client';

const INVENTORY_UNIT_SUMMARY_FIELDS = `
  id
  unitCode
  qrCode
  status
  isQrActive
  shelfLocation
  rackId
  totalPiecesPresent
  missingContentIds
  currentContents
  currentChecklist
  toy {
    id
    name
    toyNumber
  }
`;

const INSPECTION_FORM_FIELDS = `
  requiredContents {
    contentId
    name
    description
    minimumQuantity
    maximumQuantity
    defaultCount
  }
  checklist {
    id
    text
    type
    expected
    isBlocking
    defaultValue
  }
  lastInspection {
    logId
    eventType
    result
    createdAt
  }
`;

export const CHECK_INVENTORY_UNIT_ASSIGNMENT = gql`
  query CheckInventoryUnitAssignment($data: CheckInventoryUnitAssignmentInput!) {
    checkInventoryUnitAssignment(data: $data) {
      message
      data {
        canAssign
        isAlreadyAssigned
        assignmentType
        blockReason
        message
        orderItemId
        orderId
        returnOrderItemId
        returnOrderId
        assignedUnitCount
        requiredUnitCount
        unit {
          ${INVENTORY_UNIT_SUMMARY_FIELDS}
        }
        inspectionForm {
          ${INSPECTION_FORM_FIELDS}
        }
        order {
          orderNumber
          orderStatus
          isDelayed
          delayedInConfirmed
          delayedInShipped
          delayReason
          delayNote
        }
      }
    }
  }
`;

export const PICKABLE_INVENTORY_UNITS = gql`
  query PickableInventoryUnits($where: OrderItemUniqueInput!) {
    pickableInventoryUnits(where: $where) {
      orderItemId
      orderId
      orderNumber
      requiredUnitCount
      assignedUnitCount
      pendingUnitCount
      count
      data {
        unitId
        unitCode
        qrCode
        status
        isPickable
        blockReason
        shelfLocation
        missingContentCount
        totalPiecesPresent
        rack {
          id
          name
        }
      }
    }
  }
`;

export const RACKS = gql`
  query Racks($filter: RackFilter, $sort: RackSort) {
    racks(filter: $filter, sort: $sort) {
      count
      data {
        id
        name
      }
    }
  }
`;

export const RACKS_ADMIN = gql`
  query RacksAdmin($filter: RackFilter, $sort: RackSort) {
    racksAdmin(filter: $filter, sort: $sort) {
      count
      data {
        id
        name
      }
    }
  }
`;

export const GET_RETURN_INWARD_SIGNED_PUT_URL = gql`
  query GetOrderOrReturnOrderAttachmentsSignedPutUrl(
    $data: GetOrderOrReturnOrderAttachmentsSignedPutUrlInput!
  ) {
    getOrderOrReturnOrderAttachmentsSignedPutUrl(data: $data) {
      signedUrl
      fileName
    }
  }
`;

export const PREVIEW_INVENTORY_UNIT_INSPECTION = gql`
  query PreviewInventoryUnitInspection(
    $data: PreviewInventoryUnitInspectionInput!
  ) {
    previewInventoryUnitInspection(data: $data) {
      data {
        unitId
        unitCode
        qrCode
        currentStatus
        resultingStatus
        isBlocked
        requiresDamageRequest
        requiresAttachment
        message
        totalPiecesPresent
        missingContentIds
        failedPieces
        failedChecklistItems
        openDamageRequestId
      }
    }
  }
`;

export const GET_DAMAGE_REQUEST_IMAGE_SIGNED_PUT_URL = gql`
  query GetLibraryDamageRequestImageSignedPutUrl(
    $data: GetLibraryDamageRequestSignedPutUrlV2Input
  ) {
    getLibraryDamageRequestImageSignedPutUrl(data: $data) {
      fileName
      signedUrl
    }
  }
`;

export const GET_DAMAGE_REQUEST_VIDEO_SIGNED_PUT_URL = gql`
  query GetLibraryRequestToyVideoSignedPutUrl(
    $data: GetLibraryDamageRequestSignedPutUrlInput!
  ) {
    getLibraryRequestToyVideoSignedPutUrl(data: $data) {
      fileName
      signedUrl
    }
  }
`;
